// extracted by mini-css-extract-plugin
module.exports = {"modal":"AthleteActivationModal_modal__vU_IC"};